import { Link } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import './LandingNav.css';

interface LandingNavProps {
  onNavClick: (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => void;
}

export default function LandingNav({ onNavClick }: LandingNavProps) {
  const { user } = useAuth();

  return (
    <nav className="landing-nav">
      <div className="nav-inner">
        <Link to="/" className="nav-brand">
          <span className="nav-logo">🦀</span>
          <span className="nav-name">Clawee</span>
        </Link>

        <div className="nav-links">
          <a
            href="#features"
            className="nav-link"
            onClick={(e) => onNavClick(e, 'features')}
          >
            Features
          </a>
          <a
            href="#pricing"
            className="nav-link"
            onClick={(e) => onNavClick(e, 'pricing')}
          >
            Pricing
          </a>
          <a
            href="#faq"
            className="nav-link"
            onClick={(e) => onNavClick(e, 'faq')}
          >
            FAQ
          </a>
        </div>

        <div className="nav-actions">
          {user ? (
            <Link to="/dashboard" className="btn btn-primary">
              Dashboard
            </Link>
          ) : (
            <>
              <Link to="/login" className="nav-link">
                Login
              </Link>
              <Link to="/login" className="btn btn-primary">
                Get Started
              </Link>
            </>
          )}
        </div>

        {/* Mobile menu button */}
        <button className="mobile-menu-btn" aria-label="Toggle menu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
}
